//@flow
export const ENTITY_NAME_ID = 'masterOrder';
export const ENTITY_TABLE_ID = 'OrderMaster';
export const ENTITY_EXPORT_ID = 'ORDER';
export const ENTITY_TYPE = 'Order';
